<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="5">
        <el-input v-model="params.warning_name" prefix-icon="el-icon-search" placeholder="输入报警名称查询" clearable @change="onSearch()" />
      </el-col>
      <el-col :span="5">
        <el-input v-model="params.device_name" prefix-icon="el-icon-search" placeholder="输入设备名称查询" clearable @change="onSearch()" />
      </el-col>
      <el-col :span="5">
        <el-input v-model="params.owner_org_name" prefix-icon="el-icon-search" placeholder="输入所属客户查询" clearable @change="onSearch()" />
      </el-col>
      <el-col :span="2" class="col_pos_right" align="right">
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed" :sortable="it.sortable" :sort-method="(a, b) => sortDateTime(a, b, it.key)">
          <template slot-scope="scope">
            <span>{{getRowKeyVal(scope.row, it)}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange"/>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import Util from '@/api/util'

export default {
  name: '',
  data () {
    return Backend.initListPage(this, 'device_warning', {
      route_name: '实时报警列表',
      tableColList: [
        {
          key: 'warning_code',
          name: '报警代码'
        },
        {
          key: 'device_name',
          name: '设备名称',
          parent: 'device'
        },
        {
          key: 'owner_org_name',
          name: '所属客户',
          parent: 'device'
        },
        {
          key: 'warning_name',
          name: '报警名称'
        },
        {
          key: 'warning_desp',
          name: '报警描述'
        },
        {
          key: 'warning_start_time',
          name: '开始报警时间'
        },
        {
          key: 'last_warning_time',
          name: '最近报警时间'
        },
        {
          key: 'warning_count',
          name: '报警次数'
        }
      ],
      params: {
        warning_name: '',
        device_name: '',
        owner_org_name: ''
      }
    })
  },

  methods: {
    sortDateTime (a, b, key) {
      return Util.sortDateTime(a, b, key)
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    },
    getRowKeyVal (row, it) {
      return it.parent ? (row[it.parent] ? row[it.parent][it.key] : '') : row[it.key]
    }
  }
}
</script>
